import Card from "@/atoms/CardHowItWorks";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";
import Mortgage from "@/public/icons/mortgage.svg?url";
import NoDeposit from "@/public/icons/noDeposit.svg?url";
import MoveToUK from "@/public/icons/moveToUK.svg?url";
import SelfEmployed from "@/public/icons/selfEmployed.svg?url";
import EnableToBuy from "@/public/icons/enableToBuy.svg?url";
import CreditScore from "@/public/icons/creditScore.svg?url";

const WhoCanJoin = (): JSX.Element => {
  return (
    <>
      <section className="px-4 pt-12 bg-white md:px-6 lg:px-0">
        <h3 className="mb-5 text-4xl font-bold lg:text-5xl text-landing-blue md:mb-3 lg:mb-5 text-left md:text-center">
          Who can join Keyzy?
        </h3>
        <h4 className="mb-8 font-serif text-xl text-left lg:text-3xl text-landing-blue lg:mb-14 md:text-center">
          If a traditional mortgage isn’t working out, we can help if...
        </h4>
        <div className="block lg:h-[350px] lg:flex lg:justify-center lg:flex-row lg:mb-11">
          <Card
            title="You don’t have savings for a deposit"
            subtitle=""
            size="big"
            image={NoDeposit}
          />

          <HorizontalBar className="inline-block my-4 lg:hidden" />
          <VerticalBar className="hidden lg:inline-block lg:mx-20" />

          <Card
            title="You can’t get a traditional mortgage"
            subtitle=""
            size="big"
            image={Mortgage}
          />
          <HorizontalBar className="inline-block my-4 lg:hidden" />
          <VerticalBar className="hidden lg:inline-block lg:mx-20" />

          <Card title="You recently arrived in the UK" subtitle="" size="big" image={MoveToUK} />
          <HorizontalBar className="inline-block my-4 lg:hidden" />
        </div>

        <HorizontalBar className="hidden w-auto mx-20 lg:flex mb-11" />

        <div className="block lg:h-[350px] lg:flex lg:justify-center lg:flex-row lg:mb-11 mb-8">
          <Card
            title="You're in a new job or self-employed"
            subtitle=""
            size="big"
            image={SelfEmployed}
          />

          <HorizontalBar className="inline-block my-4 lg:hidden" />
          <VerticalBar className="hidden lg:inline-block lg:mx-20" />

          <Card
            title="You’re stuck renting but wanting to buy"
            subtitle=""
            size="big"
            image={EnableToBuy}
          />
          <HorizontalBar className="inline-block my-4 lg:hidden" />
          <VerticalBar className="hidden lg:inline-block lg:mx-20" />

          <Card
            title="Your credit score could be better"
            subtitle=""
            size="big"
            image={CreditScore}
          />
        </div>
      </section>
    </>
  );
};

export default WhoCanJoin;
